export default "/_next/static/videos/startuk-5889ad79cde4cd4d35c1e07e8f0aef86.mp4";